import React from 'react';

const TextArea = ({ 
  name, 
  register,
  value,
  onChange,
  onKeyPress,
  placeholder,
  info_type,
  maxLength,
  check = true,
  onBlur,
  onFocus,
  required = false
}) => {
  return (
    <textarea 
      name={name}
      id={name}
      maxLength={maxLength}
      ref={register}
      value={value && value}
      onBlur={onBlur && ((event) => onBlur(event, name, info_type))}
      onFocus={onFocus && ((event) => onFocus(event, name, info_type))}
      onChange={onChange && ((event) => onChange(event, name, info_type))}
      onKeyPress={onKeyPress && ((event) => onKeyPress(event, name, info_type))}
      placeholder={placeholder}
      disabled={!check ? "disabled" : ""}
      required={required}
    ></textarea>
  )
}

export default TextArea;